module.exports = __webpack_public_path__ + "img/blocked.d2b01b1e.svg";